<template>
    <div class="container-fluid">
        <h1>{{ $t('glyphs') }}</h1>

        <b-form-group :label="$t('star_to_portal_coordinates')" style="width: auto;">
            <b-input-group>
                <b-form-input
                    v-model="coords"
                    size="sm"
                    maxlength="19"
                    :formatter="onlyHex"/>
                <bButton
                slot="append"
                    size="sm"
                    v-if="isTouch"
                    @click="displayHexKeys = !displayHexKeys"
                    >
                    <font-awesome-icon icon="keyboard"></font-awesome-icon>
                </bButton>
            </b-input-group>
            <b-form-text id="inputLiveHelp">
                {{ $t('enter_last_four_blocks') }}
                <span style="white-space: nowrap;">(<span :class="$style.bright"><span :class="$style.nope">XXXX :</span>
                <span :class="$style.green">&check;&check;&check;&check;</span> <span :class="$style.nope"> : </span>
                <span :class="$style.green">&check;&check;&check;&check;</span> <span :class="$style.nope"> : </span>
                <span :class="$style.green">&check;&check;&check;&check;</span> <span :class="$style.nope"> : </span>
                <span :class="$style.green">&check;&check;&check;&check;</span></span>)</span>
            </b-form-text>
        </b-form-group>

        <p v-if="displayHexKeys" :class="$style.hexKeys">
            <bButton
                v-for="i in '0123456789ABCDEF'"
                :key="i"
                variant="outline-light"
                @touchstart="addToCoords(i)"
                >
                {{i}}
            </bButton>
            <bButton @click="deleteFromCoords">
                <font-awesome-icon icon="backspace"></font-awesome-icon>
            </bButton>
            <bButton @click="displayHexKeys = !displayHexKeys">
                <font-awesome-icon icon="times"></font-awesome-icon>
            </bButton>
        </p>

        <p v-if="glyphsGenerated" :class="$style.glyphs">{{ glyphsGenerated }}</p>
        <glyph-canvas :coords="coordsFormated" :glyphs="glyphsGenerated"/>

        <p v-if="glyphsGenerated">
            {{ $t('coordinates') }}: <code>{{ coordsFormated }}</code><br>
            {{ $t('glyphs') }}: <code>{{ glyphsGenerated }}</code>
        </p>

        <!-- <p>
            <code>07fe:0077:07fd:00ec</code> => <code>00ECF8FFEFFF</code><br>
            <code>0821:0081:0A21:0045</code> => <code>004502222022</code>
        </p> -->

        <p class="small fixed-bottom ml-3">
            credits: <a href="https://www.reddit.com/r/NMSCoordinateExchange/wiki/tutorials/convert_portal_coordinates">r/.../convert_portal_coordinate</a>,
            <a href="https://www.reddit.com/user/rogerhnn">u/rogerhnn</a>
        </p>

    </div>
</template>

<script>
// import Vue from 'vue';
import bButton from 'bootstrap-vue/es/components/button/button';
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import bInputGroup from 'bootstrap-vue/es/components/input-group/input-group';
import bFormText from 'bootstrap-vue/es/components/form/form-text';
import GlyphCanvas from '@/components/GlyphsCanvas';
import utils from '@/mixins/utils';
export default {
    data () {
        return {
            coords: '',
            coords_a: '',
            coords_b: '',
            coords_c: '',
            coords_d: '',
            interval: false,
            randomFour: 'XXXX',
            invisible: false,
            displayHexKeys: false
        };
    },
    mixins: [
        utils
    ],
    components: {
        bButton,
        bFormGroup,
        bFormInput,
        bInputGroup,
        bFormText,
        GlyphCanvas
    },
    computed: {
        glyphsGenerated () {
            if (this.coords.length !== 16) {
                return '';
            }

            const coords = this.coords.match(/.{1,4}/g);

            const bigShift = parseInt('801', 16);
            const smallShift = parseInt('81', 16);
            const bigMod = parseInt('1000', 16);
            const smallMod = parseInt('100', 16);

            const x = coords[0];
            const y = coords[1];
            const z = coords[2];
            const p = coords[3].substr(0, 1);
            const s = coords[3].substr(1, 3);

            const a = p.toUpperCase();
            const b = s.toUpperCase();
            const c = this.shiftModUpFill(y, smallShift, smallMod, 2);
            const d = this.shiftModUpFill(z, bigShift, bigMod, 3);
            const e = this.shiftModUpFill(x, bigShift, bigMod, 3);

            return (a + b + c + d + e);
        },
        coordsFormated () {
            return (this.coords + '________________').slice(0, 16).match(/.{1,4}/g).join(':');
        }
    },
    methods: {
        generateRandomFour () {
            if (window.crypto && window.crypto.getRandomValues) {
                const length = 4;
                const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                let result = '';
                let values = new Uint32Array(length);
                window.crypto.getRandomValues(values);
                for (let i = 0; i < length; i++) {
                    result += charset[values[i] % charset.length];
                }
                return result;
            }

            return 'XXXX';
        },
        shiftModUpFill (val, shift, mod, length) {
            return ('00' + Math.abs((parseInt(val, 16) + shift) % mod).toString(16).toUpperCase()).slice(-length);
        },
        addToCoords (i) {
            this.coords = this.coords + i;
        },
        deleteFromCoords () {
            this.coords = this.coords.slice(0, this.coords.length - 1);
        }
    },
    mounted () {
        this.interval = window.setInterval(() => {
            this.invisible = true;
            setTimeout(() => {
                this.randomFour = this.generateRandomFour();
                this.invisible = false;
            }, 1000);
        }, 3000);
    }
};
</script>

<style module lang="scss">
    .coordsForm {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 0.5em;

        @media (min-width: 390px) {
            grid-template-columns: 3em minmax(min-content, max-content) 4em minmax(min-content, max-content) 4em minmax(min-content, max-content) 4em minmax(min-content, max-content) 4em;
        }
    }

    .coordsForm > span {
        display: none;

        @media (min-width: 390px) {
            display: initial;
        }
    }

    .glyphs {
        display: inline-block; // inline-block
        text-transform: uppercase;
        font-family: "glyphs-tight";
        font-size: calc((100vw - 10px) / 12 + 0.2em);
        letter-spacing: 0.1em;

        // border: 1px solid #E42200;
        // line-height: 1;
        // padding: 4px 9px;

        @media (min-width: 36em) {
            font-size: 50.2px;
        }
    }

    .glyphs > * {
        flex-grow: 1;
    }

    .bright {
        color: white;
    }

    .nope {
        color: red;
    }

    .green {
        color: lightgreen;
    }

    .four {
        opacity: 1;
        visibility: visible;
        transition: visibility 0.3s linear,opacity 0.3s linear;
        text-align: right;
    }

    .invisible {
        opacity: 0;
        visibility: hidden;
    }

    .hexKeys {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-gap: 0.5em;
        line-height: 3em;
        user-select: none;
    }

    .hexKeys > *:nth-child(17) {
        grid-area: 2 / -1 / 3 / -2;
    }

    .hexKeys > *:nth-child(18) {
        grid-area: 1 / -1 / 1 / -2;
    }
</style>
